<!-- payment -->
<template>
  <div class="personal-own">
    <ul>
      <li v-if="!!info.capacityInfo">
        <div class='personal-own-container'>
          <h1>Capacity - your maximum number of mentees each year</h1>
          <div class="personal-own-info">
            <div class="personal-own-info-list">
              <span>Mentor Type</span>
              <span>{{info.capacityInfo.mentorRole}}</span>
            </div>
            <div class="personal-own-info-list"
                 v-for="(item, index) in info.capacityInfo.capacityInfos"
                 :key="index">
              <span>Capacity({{item.year}})</span>
              <span>{{`${item.acCount || 0 }/${item.count || 0}`}}</span>
            </div>
            <div class="personal-own-info-list">
              <span>Availability</span>
              <span>{{info.capacityInfo.availability}}</span>
            </div>
          </div>
          <!--这里时间只在2020-01-01到2020-01-15开放编辑，发版前，考虑先注释掉-->
          <!-- v-if="hasEditAccess" -->
          <img :src="editIcon"
               alt="edit"
               class="personal-own-edit"
               @click="editHandle" />
        </div>
      </li>
      <li v-if="userRole === 'SM' || userRole === 'CM'">
        <div>
          <h1>Honorarium rate</h1>
          <div class="personal-own-info">
            <div class="personal-own-info-list">
              <span>${{(info.wageInfo && info.wageInfo.wage) || 0}}/hr (effective starting from {{info.wageInfo && info.wageInfo.wageUpdateTime}})</span>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div>
          <h1>Payment
            <img :src="editIcon"
               alt="edit"
               class="personal-own-edit"
               @click="editPaymentHandle">
          </h1>
          <div class="personal-own-info">
            <div class="personal-own-info-list">
              <span>Chinese citizen</span>
              <span>{{info.paymentInfo.paymentInfo.chineseCitizen ===1?'YES':'NO'}}</span>
            </div>
            <div class="personal-own-info-list">
              <span>Payment method</span>
              <span>{{info.paymentInfo.paymentInfo.payWay === 'PAYPAL'? 'Paypal': '云账户'}}</span>
            </div>
            <template v-if="paymentData.payWay === 'PAYPAL'">
              <div class="personal-own-info-list">
                <span>Account Currency</span>
                <span>{{paymentData.currency}}</span>
              </div>
              <div class="personal-own-info-list">
                <span>PayPal</span>
                <span>{{paymentData.payPalEmail}}</span>
              </div>
              <div class="personal-own-info-list">
                <span>Registe Country</span>
                <span>{{paymentData.registeCountry}}</span>
              </div>
            </template>
            <template v-else>
              <div class="personal-own-info-list">
                <span>收款人姓名</span>
                <span>{{paymentData.payeeName}}</span>
              </div>
              <div class="personal-own-info-list">
                <span>手机号</span>
                <span>{{paymentData.payeePhone}}</span>
              </div>
              <div class="personal-own-info-list">
                <span>银行卡号</span>
                <span>{{paymentData.cardNumber}}</span>
              </div>
              <div class="personal-own-info-list"
                   v-if="paymentData.nationality==='NATIONAL'">
                <span>身份证号</span>
                <span>{{paymentData.payeeIdCard}}</span>
              </div>
              <div class="personal-own-info-list"
                   v-if="paymentData.nationality==='UNNATIONAL'">
                <span>{{paymentData.payeeIdType==='PASSPORT'?"护照号":"港澳台来往内地通行证号"}}</span>
                <span>{{paymentData.payeeIdCard}}</span>
              </div>
              <div v-if="paymentData.nationality!=='NATIONAL'&&paymentData.screenshot"><span style="color: #2D8CF0;cursor:pointer;margin-left:600px;" @click="downloadHandler">Download</span></div>
            </template>
          </div>
        </div>
      </li>
      <li>
        <div class="personal-own-prompt">
          If you want to update “Capacity / Payment”, please contact Zailairen valeon mentor department.
        </div>
      </li>
    </ul>
    <div v-show="capacityStatus">
      <capacityEditCom :status="capacityStatus" :userRole="userRole" :capacityInfos="info" @success="capacityCallback"></capacityEditCom>
    </div>
    <applySelectModal :value='editMoreModal'>
      <div name='slot'>
        <h1>Capacity</h1>
        <p class='capacity-edit-title'>How many mentees would you like to take on？</p>
        <div style="margin-bottom: 20px;color: #ababab;">Notes: 2022 means the mentee is applying for 2022 fall enrollment, therefore you will help the mentees mostly in 2021 fall. Please ignore the capacity modification of 2020 and 2021.</div>
        <div v-if="userRole === 'SM' || userRole === 'CM'">
          <Form ref="formValidateSMCM"
                :model="formValidateSMCM"
                class='apply-capacity-modal'>
                {{info.capacityInfo.capacityInfos}}
            <div class="apply-capacity-select"
                 v-for='(item, index) in info.capacityInfo.capacityInfos'
                 :key='index'>
              <FormItem :label="`${item.year}`"
                        :prop='`capacityInfos.${index}`'
                        :rules="{required: true, message: promptSelect}">
                <Cascader :data="menteeNumList"
                          :disabled="item.year===2020 ||item.year===2021"
                          @on-change="handleChange($event,index,item.year)"
                          v-model="formValidateSMCM.capacityInfos[index]"></Cascader>
              </FormItem>
            </div>
          </Form>
        </div>
        <div v-if="userRole === 'EM'">
          <Form ref="formValidateEM"
                :model="formValidateEM"
                class='apply-capacity-modal'>
            <div class="apply-capacity-select"
                 v-for='(item, index) in info.capacityInfo.capacityInfos'
                 :key='index'>
              <FormItem :label="`${item.year}`"
                        :prop='`capacityInfos.${index}`'
                        :rules="{required: true, message: promptSelect}">
                <Select v-model="formValidateEM.capacityInfos[index]"
                        placeholder="Select"
                        clearable>
                  <Option :value="0">0</Option>
                  <Option v-for="subItem in 50"
                          :value='subItem'
                          :key="subItem">{{subItem}}</Option>
                </Select>
              </FormItem>
            </div>
          </Form>
        </div>
        <div class="apply-capacity-btn">
          <Button class="zlr-btn-primary"
                  @click="subHandle"
                  :loading="hasEditMore">Submit</Button>
          <Button class="zlr-btn-default"
                  @click="closeHandle">Close</Button>
        </div>
      </div>
    </applySelectModal>
    <applySelectModal :value="isPaymentEdit">
      <div name='slot'>
        <paymentEdit :info="paymentData" @on-submit="onPaymentInfoSubmit" @on-cancel="isPaymentEdit=false"></paymentEdit>
      </div>
    </applySelectModal>
  </div>
</template>
<script>
// api
import { getPaymentinfo, capacityEdit, capacityEditAccess } from '@/api/talents'
import { mapState } from 'vuex'
import applySelectModal from '../../components/modal/modal'
import editIcon from '@/assets/images/home/edit.svg'
import { promptSelect } from '@/constant'
import paymentEdit from './payment-edit.vue'
import { ossSecretLink} from '@/api/oss'
// capacity
import capacityEditCom from './capacity-edit.vue'
export default {
  name: 'personal-payment',
  components: {
    applySelectModal,
    paymentEdit,
    capacityEditCom
  },
  data () {
    return {
      capacityStatus: false,
      paymentData:{},
      isPaymentEdit:false,
      // 校验提示信息
      promptSelect,
      editIcon,
      info: {
        capacityInfo: {
          capacityInfos: []
        },
        paymentInfo: {
          paymentInfo: {},
          otherInfo: {}
        }
      },
      hasEditAccess: false,
      menteeNumList: [
        {
          value: '1',
          label: '1 mentee'
        },
        {
          value: '2',
          label: '2 mentee'
        },
        {
          value: '3',
          label: '3 mentee'
        },
        {
          value: 'more',
          label: 'More than 3 mentees',
          children: [
            {
              value: '4',
              label: '4 mentee'
            },
            {
              value: '5',
              label: '5 mentee'
            },
            {
              value: '6',
              label: '6 mentee'
            },
            {
              value: '7',
              label: '7 mentee'
            },
            {
              value: '8',
              label: '8 mentee'
            },
            {
              value: '9',
              label: '9 mentee'
            },
            {
              value: '10',
              label: '10 mentee'
            }
          ]
        }
      ],
      // Payment Edit 弹窗标识
      editMoreModal: false,
      // loading 状态
      hasEditMore: false,
      formValidateSMCM: {
        capacityInfos: []
      },
      formValidateEM: {
        capacityInfos: []
      },
      oldFormValidateSMCM: {
        capacityInfos: []
      }
    }
  },
  computed: {
    ...mapState({
      userRole (state) {
        return state.user.userRole
      }
    })
  },
  mounted () {
    this.getPaymentinfo()
    // this.getEditAccess()
  },
  methods: {
    capacityCallback (status) {
      if (status){
        this.$zlr_message('Edit Success', 'success')
        this.getPaymentinfo()
      }
      this.capacityStatus = false
    },
    downloadHandler(){
      ossSecretLink({
        dir: this.paymentData.screenshot
      }).then(res => {
        console.log(res)
        window.open(res.data.url)
      })
    },
    onPaymentInfoSubmit () {
      this.isPaymentEdit = false
      this.getPaymentinfo()
    },
    editPaymentHandle(){
      console.log(3333333)
      this.isPaymentEdit = true
    },
    getPaymentinfo () {
      getPaymentinfo({}).then(res => {
        this.info = res.data
        this.paymentData = this.info.paymentInfo.paymentInfo
      })
    },
    getEditAccess () {
      capacityEditAccess({}).then(res => {
        this.hasEditAccess = res.data.model
      })
    },
    // capacity Edit
    editHandle(){
      this.capacityStatus = true
      
    },
    // Capacity Edit more Submitconsole.log(item)
    subHandle () {
      // 根据角色赋值
      let capacityInfos = []

      if (this.userRole === 'SM' || this.userRole === 'CM') {
        this.$refs.formValidateSMCM.validate((valid) => {
          if (valid) {
            let smallNum = []
            this.formValidateSMCM.capacityInfos.forEach((item, index) => {
              let itemNumber = Number(item[item.length - 1])
              let oldItemNumber = Number(this.oldFormValidateSMCM.capacityInfos[index][this.oldFormValidateSMCM.capacityInfos[index].length - 1])
              let year = this.info.capacityInfo.capacityInfos[index].year
              if (itemNumber < oldItemNumber) {
                this.$zlr_message(year + ':You cannot select a value smaller than the current option')
                smallNum.push(item)
              }
            })
            if (smallNum.length === 0) {
              this.hasEditMore = true
              this.formValidateSMCM.capacityInfos.map((item, index) => {
                capacityInfos.push({
                  year: this.info.capacityInfo.capacityInfos[index].year,
                  count: Number(item[item.length - 1])
                })
              })
              // 调用接口
              this.submitEdit(capacityInfos)
            }
          }
        })
      }
      if (this.userRole === 'EM') {
        this.$refs.formValidateEM.validate((valid) => {
          if (valid) {
            this.hasEditMore = true
            this.formValidateEM.capacityInfos.map((item, index) => {
              capacityInfos.push({
                year: this.info.capacityInfo.capacityInfos[index].year,
                count: Number(item)
              })
            })
            // 调用接口
            this.submitEdit(capacityInfos)
          }
        })
      }
    },
    // capacity Edit api
    submitEdit (capacity) {
      // 调用接口
      capacityEdit({ capacity: capacity }).then(res => {
        this.hasEditMore = false
        this.editMoreModal = false
        this.$zlr_message('Edit Success', 'success')
        this.getPaymentinfo()
      }).catch(error => {
        this.hasEditMore = false
        this.$zlr_message(error.message, 'error')
      })
    },
    // Capacity Edit more Close
    closeHandle () {
      this.editMoreModal = false
    },
    handleChange (event, index, year) {
      console.log(event, index, year)
      let changeVal = event[event.length - 1]
      let oldValLength = this.oldFormValidateSMCM.capacityInfos[index].length
      let oldVal = this.oldFormValidateSMCM.capacityInfos[index]
      if (oldVal && oldVal.length > 0) {
        if (Number(changeVal) < Number(oldVal[oldValLength - 1])) {
          this.$zlr_message(year + ':You cannot select a value smaller than the current option')
          return false
        } else {
          this.formValidateSMCM.capacityInfos[index] = event
        }
      } else {
        this.formValidateSMCM.capacityInfos[index] = event
      }
    }
  }
}
</script>
<style lang='less' scoped>
</style>
